/**
 * Warms a lazily imported module once the browser is idle, so a deferred chunk
 * is already in memory when the interaction that needs it happens. A failed
 * prefetch stays silent; the on-demand import is still the real load path.
 */
export function prefetchWhenIdle(load: () => Promise<unknown>): () => void {
  let cancelled = false;
  const run = () => {
    if (cancelled) return;
    void load().catch(() => undefined);
  };

  if (typeof requestIdleCallback === "function") {
    const handle = requestIdleCallback(run, { timeout: 2000 });
    return () => {
      cancelled = true;
      cancelIdleCallback(handle);
    };
  }

  const handle = window.setTimeout(run, 200);
  return () => {
    cancelled = true;
    window.clearTimeout(handle);
  };
}
